import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['toggleFrom']

  toggleAutomation() {
    let form = $(event.target).closest('[data-automations-target="toggleFrom"]').get(0)
    Rails.ajax({url: form.action, type: form.method, data: $(form).serialize(), dataType: 'script'});
  }
}
